export const isKeyValueEqualBetweenObjects = (keyValueObjectToCompare, keyValueObjectRef) => {
  let isEqual = true;
  for (const [fieldName] of Object.entries(keyValueObjectToCompare)) {
    isEqual = isEqual && keyValueObjectToCompare[fieldName].value === keyValueObjectRef[fieldName];
  }
  return isEqual;
};
